// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"ab5c9f9b","408":"e5885d72","453":"141d864c","479":"7b36d7b6","699":"5ca4ffe1","778":"89cd492d","784":"65000e8d","821":"0cec88ed"}[chunkId] + ".chunk.js";
};